import { render } from "./VueHeader.vue?vue&type=template&id=6c4b91cf"
import script from "./VueHeader.vue?vue&type=script&lang=js"
export * from "./VueHeader.vue?vue&type=script&lang=js"

import "./VueHeader.vue?vue&type=style&index=0&id=6c4b91cf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__